import Chevron from "../Chevron/Chevron";
import { BLUE_RIBBON_500, GRAYSCALE_300 } from "../../styles/colors";
import { ChevronWrapper, ContentWrapper, IconContainer, ListItemContainer, MethodDescription, MethodTitle, TextContainer } from "./ListItem.styles";

interface ListItemProps {
    title: string;
    description: string;
    icon: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    chevronPosition?: 'inside' | 'outside';
    chevronWidth?: number
}

const ListItem = ({ title, description, icon, onClick, disabled = false, chevronPosition = 'outside', chevronWidth = 1 }: ListItemProps) => {
    const handleClick = () => {
        if (!disabled) {
            onClick();
        }
    };

    const chevronElement = (
        <ChevronWrapper>
            <Chevron color={disabled ? GRAYSCALE_300 : BLUE_RIBBON_500} strokeWidth={chevronWidth} size={12} />
        </ChevronWrapper>
    );

    return (
        <ListItemContainer onClick={handleClick} disabled={disabled}>
            <ContentWrapper>
                <IconContainer disabled={disabled}>
                    {icon}
                </IconContainer>
                <TextContainer>
                    <MethodTitle disabled={disabled}>{title}</MethodTitle>
                    <MethodDescription disabled={disabled}>{description}</MethodDescription>
                </TextContainer>
                {chevronPosition === 'inside' && chevronElement}
            </ContentWrapper>
            {chevronPosition === 'outside' && chevronElement}
        </ListItemContainer>
    );
};

export default ListItem;
export type { ListItemProps };
